var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickerType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46 11.736a5.205 5.205 0 002.89 1.996M8.446 8.811a.365.365 0 010-.73M8.446 8.811a.365.365 0 000-.73M13.553 8.811a.365.365 0 010-.73M13.554 8.811a.365.365 0 100-.73",
    stroke: "#575757",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.045 13.86a9.48 9.48 0 00.439-2.86A9.484 9.484 0 1011 20.484c.996 0 1.957-.154 2.859-.439l6.186-6.186z",
    stroke: "#575757",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.045 13.86a4.377 4.377 0 10-6.186 6.186l6.186-6.187z",
    stroke: "#575757",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgStickerType;